import { Link } from "react-router-dom";
const Request = ({ data = 0 }) => {
  return (
    <>
      <Link to="/demo">
        <button className={`btn btn-primary me-3 mt-${data}`}>
          Request Demo
        </button>
      </Link>
    </>
  );
};

export default Request;
